import { render, staticRenderFns } from "./NeoparentReadmit.vue?vue&type=template&id=9a34602a&scoped=true"
import script from "./NeoparentReadmit.vue?vue&type=script&lang=js"
export * from "./NeoparentReadmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a34602a",
  null
  
)

export default component.exports